import XeroSettings from 'pages/Xero/Settings/Landing'
import HrSettings from 'pages/PayrollHrNew/SettingsManagement'
import { Trans } from "react-i18next";
import { all, any, check_permissions } from 'Helpers'
import { useUserContext } from "hooks";
import BackButton from 'components/refactoring/BackButton';
import { userAndSubsPerms } from 'pages/PermissionsList';
import UsersPage from 'pages/UsersPage/Home';

export default function SettingsAll(props) {
    const { user, permissions } = useUserContext();
    return (
        <>
            <div className="container">
            <BackButton/>
                <h4 className='mb-3'><Trans>General Settings</Trans></h4>
                {check_permissions(permissions, userAndSubsPerms, all) &&
                    <UsersPage getback={false} {...props}></UsersPage>
                }
                <div className="my-3"/>
                {check_permissions(permissions, ['xero_settings'], any) &&
                    <XeroSettings {...props}></XeroSettings>
                }
                <div className="my-3"/>
                {check_permissions(permissions, ['hr_settings'], any) &&
                    <HrSettings {...props}></HrSettings>
                }
            </div>
        </>

    )
}